<section class="faq">
    <div class="col-md-12 title">
        {{faqs.header?.title}}
    </div>
    <div class="col-md-12 subtitle">
        {{faqs.header?.subtitle}}
    </div>
    <div class="faqContainer">
        <div class="row">
            <div class="col-xs-12 col-lg-6 left" *ngFor="let faq of faqs.preguntas_respuestas | slice:0:3">
                <div class="questionContainer">
                    <p class="question"><strong class="redLine"></strong> {{faq.question}}</p>
                    <p class="answer">{{faq.quick_answer}}</p>
                    <a mat-flat-button href="landing{{faq.link}}" target="_self">Ver más</a>
                </div>
            </div>
            <div class="col-xs-12 col-lg-6 right hidden-xs" *ngFor="let faq of faqs.preguntas_respuestas | slice:4:6">
                <div class="questionContainer">
                    <p class="question"><strong class="redLine"></strong> {{faq.question}}</p>
                    <p class="answer">{{faq.answer}}</p>
                    <a mat-flat-button href="landing{{faq.link}}" target="_self">Ver más</a>
                </div>
            </div>
        </div>
    </div>
</section>
